import React, { useState } from "react";
import { BankOutlined, QrcodeOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Radio, Space, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const PayoutForm = ({ isVisible, onClose, onPayoutSubmit }) => {
  const [form] = Form.useForm();
  const [payoutMethod, setPayoutMethod] = useState("usdt");
  const themeColor = "linear-gradient(90deg, #f178e2 0%, #9b59f6 50%, #0ed2f7 100%)";

  const handlePayoutMethodChange = (e) => {
    setPayoutMethod(e.target.value);
  };

  const handleSubmit = async (values) => {
    try {
      await onPayoutSubmit?.(values, payoutMethod);
      form.resetFields();
    } catch (error) {
      console.error("Payout submission failed:", error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const renderPayoutForm = () => {
    if (payoutMethod === "usdt") {
      return (
        <>
          <Form.Item name="walletAddress" label="Wallet Address" rules={[{ required: true, message: "Wallet address is required" }]}>
            <Input placeholder="Enter your USDT wallet address" />
          </Form.Item>
          <Form.Item
            name="qrCode"
            label="QR Code"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) {
                return e;
              }
              return e?.fileList;
            }}
            rules={[
              {
                required: true,
                message: 'Please upload your QR code',
                validator: (_, value) =>
                  value && value[0]?.originFileObj ? Promise.resolve() : Promise.reject('QR code is required')
              }
            ]}
          >
            <Upload
              accept="image/*"
              maxCount={1}
              beforeUpload={() => false} // Prevent automatic upload
              listType="picture"
            >
              <Button icon={<UploadOutlined />}>Click to upload QR Code</Button>
            </Upload>
          </Form.Item>
          <Form.Item name="walletName" label="Wallet Name" rules={[{ required: true, message: "Wallet name is required" }]}>
            <Input placeholder="e.g., Trust Wallet, MetaMask" />
          </Form.Item>
          <Form.Item name="name" label="Name" rules={[{ required: true, message: "Name is required" }]}>
            <Input placeholder="Enter your full name" />
          </Form.Item>
        </>
      );
    }
    return (
      <>
        <Form.Item name="bankName" label="Bank Name" rules={[{ required: true, message: "Bank name is required" }]}>
          <Input placeholder="Enter your bank name" />
        </Form.Item>
        <Form.Item name="accountName" label="Account Name" rules={[{ required: true, message: "Account name is required" }]}>
          <Input placeholder="Enter the account holder’s name" />
        </Form.Item>
        <Form.Item name="accountNumber" label="Account Number" rules={[{ required: true, message: "Account number is required" }]}>
          <Input placeholder="Enter your account number" />
        </Form.Item>
        <Form.Item name="ifscCode" label="IFSC Code" rules={[{ required: true, message: "IFSC code is required" }]}>
          <Input placeholder="Enter your bank IFSC code" />
        </Form.Item>
        <Form.Item name="city" label="City" rules={[{ required: true, message: "City is required" }]}>
          <Input placeholder="Enter your city" />
        </Form.Item>
      </>
    );
  };

  return (
    <Modal title="Request Payout" open={isVisible} onCancel={handleCancel} footer={null} width={600}>
      <Form form={form} layout="vertical" onFinish={handleSubmit} initialValues={{ payoutMethod: "usdt" }}>
        <Form.Item name="payoutMethod" label="Select Payout Method">
          <Radio.Group
            onChange={handlePayoutMethodChange}
            style={{
              width: "100%",
              display: "flex",
              gap: "8px",
            }}
            buttonStyle="solid"
          >
            <Radio.Button
              value="usdt"
              style={{
                flex: 1,
                textAlign: "center",
                borderRadius: "4px",
                margin: 0,
                border: "1px solid #d9d9d9",
                color: "#000",
                transition: "all 0.3s",
              }}
            >
              <Space>
                <QrcodeOutlined /> USDT
              </Space>
            </Radio.Button>
            <Radio.Button
              value="bank"
              style={{
                flex: 1,
                textAlign: "center",
                borderRadius: "4px",
                margin: 0,
                border: "1px solid #d9d9d9",
                color: "#000",
                transition: "all 0.3s",
              }}
            >
              <Space>
                <BankOutlined /> Bank Transfer
              </Space>
            </Radio.Button>
          </Radio.Group>
        </Form.Item>

        {renderPayoutForm()}

        <div style={{ textAlign: "right", marginTop: 24 }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" style={{ background: themeColor, color: "#fff", border: "none" }}>
            Submit Request
          </Button>
        </div>
      </Form>
    </Modal>
  );

};

export default React.memo(PayoutForm);
